import Image from 'next/image';

/**
 * dotCMS Image for card component
 * If there is no image, it will show a placeholder
 *
 * @param {*} { quality, src, alt, placeholderFontSize}
 * @return {*}
 */
export const DotCardImage = ({
    quality,
    src,
    alt,
    placeholderFontSize,
    priority = false,
    deviceType = 'desktop'
}) => {
    const getSizes = () => {
        const fallback = 'calc(100vw - 32px)';

        const map = {
            mobile: 'calc(100vw - 32px)',
            tablet: '(max-width: 1200px) calc(50vw - 32px), calc(33vw - 32px)',
            desktop: '(max-width: 1200px) calc(50vw - 32px), calc(33vw - 32px)'
        };

        if (!deviceType || typeof map[deviceType] === 'undefined') {
            return fallback;
        }

        return map[deviceType];
    };

    return (
        <>
            {src ? (
                <Image
                    src={src}
                    quality={quality || 70}
                    className="object-cover"
                    alt={alt || 'dotCMS Site Image'}
                    fill={true}
                    priority={priority}
                    sizes={getSizes()}
                />
            ) : (
                <ImagePlacerholder placeholderFontSize={placeholderFontSize} />
            )}
        </>
    );
};

/**
 *
 *
 * @param {*} { placeholderFontSize }
 * @return {*}
 */
export const ImagePlacerholder = ({ placeholderFontSize = '' }) => {
    return (
        <div className="flex size-full items-center justify-center bg-gradient-to-r from-fuschia-500 via-fuschia-700 to-fuschia-800 text-white">
            <span className="text-5xl" style={{ fontSize: placeholderFontSize }}>
                dotCMS
            </span>
        </div>
    );
};
